export default __webpack_public_path__ + "static/media/mintgb.6ab336b4.jpg";